<template lang="pug">
.py-2.local
  div
    .h6 Qual o local da ocorrência?
    .text-small Informe o local onde ocorreu a situação
  .mt-2
    endereco-map(
      :value="model.endereco_formatado"
      placeholder="Digite o endereço com o número",
      @select-endereco="onSelectEndereco"
    )
    form-group(label="Complemento")
      input.form-input(v-model="model.endereco_complemento" placeholder="Ex: Apartamento, Bloco, etc.")
  .text-right.mt-2
    button.btn.btn-primary(:disabled="$v.model.$invalid" @click="onNext")
      | Avançar&nbsp;
      i.fa.fa-arrow-right
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";

export default {
  vuex: {
    ocorrencias: {
      state: ["form"],
      mutations: ["setForm"],
    },
  },
  data() {
    return {
      model: {
        endereco_formatado: "",
        endereco_numero: "",
        endereco_complemento: "",
        point: null,
      }
    }
  },
  validations: {
    model: {
      endereco_formatado: { required },
      endereco_numero: { required, minLength: minLength(1), maxLength: maxLength(100) },
      point: { required },
      complemento: {}
    }
  },
  methods: {
    onSelectEndereco(endereco) {
      const { endereco_formatado, endereco_numero, geometry } = endereco;
      const point = { type: 'Point', coordinates: [geometry.location.lng, geometry.location.lat] };
      this.model = { ...this.form, endereco_formatado, endereco_numero, point };
    },
    onNext() {
      this.setForm({
        ...this.form,
        ...this.model, 
      });
      this.$router.push({ name: "app.ouvidoria.create.descricao" });
    }
  },
  created() {
    if (this.form) {
      this.model.endereco_formatado = this.form.endereco_formatado || "";
      this.model.endereco_numero = this.form.endereco_numero || "";
      this.model.point = this.form.point;
      this.model.endereco_complemento = this.form.endereco_complemento || "";
    }
  }
};
</script>

<style lang="stylus">
.local .map
  height: 400px
  border-radius: 5px
  overflow: hidden
  width: 100%
  margin: 1rem 0

</style>
